/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatalistAnagrafica } from '@models';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-opera-tab-dati-costruttivi-opera',
    templateUrl: './tab-dati-costruttivi-opera.component.html',
})
export class ToolkitGestioneOperaTabDatiCostruttiviOperaComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    @Input() datalist: DatalistAnagrafica;
    readonly natural = CurrencyMaskInputMode.NATURAL;


    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }
    }

}
